<template lang="html">
  <div class="wrapper">
    <headerBar></headerBar>
    <div class="container">
      <!-- <p4a-brandbar :showSidebarButton="false"></p4a-brandbar> -->
      <div class="login">
        <router-view name="loginOptions"></router-view>
        <router-view @authenticated="setAuthenticated"></router-view>
      </div>
      <div class="atmosphere"></div>
    </div>
  </div>
</template>

<script>
import headerBar from '../header/header'

export default {
  name: 'LoginContainer',
  components: {
    'headerBar': headerBar
  },
  data () {
    return {
      authenticated: false,
      account: {
        username: 'admin',
        password: 'admin'
      }
    }
  },
  mounted () {
    if (!this.authenticated) {
      this.$router.replace({ route: '/', query: this.$route.query }).catch(err => { return err })
    }
  },
  methods: {
    setAuthenticated (status) {
      this.authenticated = status
    }
  }
}
</script>

<style lang="scss" scoped>
  .close-sidebar { display: none; }
  .atmosphere {
    background-image: url('/api/server/customerdata/customloginbackground.jpg');
  }
</style>



// WEBPACK FOOTER //
// src/components/login/loginContainer.vue